/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "utils/api-client-wrapper";
import type { PutV1UsersIdMutationRequest, PutV1UsersIdMutationResponse, PutV1UsersIdPathParams, PutV1UsersId422 } from "../../../types/PutV1UsersId.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "utils/api-client-wrapper";

function getPutV1UsersIdUrlClient({ id }: { id: PutV1UsersIdPathParams["id"] }) {
  const res = { method: 'PUT', url: `/v1/users/${id}` as const }
  return res
}

/**
 * @summary Update user
 * {@link /v1/users/:id}
 */
export async function putV1UsersIdClient({ id }: { id: PutV1UsersIdPathParams["id"] }, data: PutV1UsersIdMutationRequest, config: Partial<RequestConfig<PutV1UsersIdMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PutV1UsersIdMutationResponse, ResponseErrorConfig<PutV1UsersId422>, PutV1UsersIdMutationRequest>({ method : "PUT", url : getPutV1UsersIdUrlClient({ id }).url.toString(), data : requestData, ... requestConfig })
  return res
}